export class ParametrosCobrosAuto {
  idParametro?: number;
  delimitador: string;
  nombreFormato: string;
  linIniDatos: number;
  tipoDocumento: string;
  poscSigno: number;
  poscValor: number;
  poscReferencia: number;
  poscNumDocumento: number;
  numComprobamPresent: false;
  posColumComproban: number;
  posFilaComproban: number;
  totalPresent: boolean;
  posColumTot: number;
  posFilaTot: number;

  constructor(innParametros: ParametrosCobrosAuto) {
    this.idParametro = innParametros.idParametro;
    this.delimitador = innParametros.delimitador;
    this.nombreFormato = innParametros.nombreFormato;
    this.linIniDatos = innParametros.linIniDatos;
    this.tipoDocumento = innParametros.tipoDocumento;
    this.poscSigno = innParametros.poscSigno;
    this.poscValor = innParametros.poscValor;
    this.poscReferencia = innParametros.poscReferencia;
    this.poscNumDocumento = innParametros.poscNumDocumento;
    this.numComprobamPresent = innParametros.numComprobamPresent;
    this.posColumComproban = innParametros.posColumComproban;
    this.posFilaComproban = innParametros.posFilaComproban;
    this.totalPresent = innParametros.totalPresent;
    this.posColumTot = innParametros.posColumTot;
    this.posFilaTot = innParametros.posFilaTot;
  }

  
}
